var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEndlessCallsEmails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 130,
    viewBox: "0 0 136 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 93.6C132 96.9948 130.651 100.251 128.251 102.651C125.851 105.051 122.595 106.4 119.2 106.4H34.8992C31.5047 106.401 28.2495 107.75 25.8496 110.15L11.7568 124.243C11.1213 124.879 10.3117 125.311 9.43033 125.487C8.54896 125.662 7.6354 125.572 6.80517 125.228C5.97493 124.884 5.2653 124.302 4.76599 123.555C4.26668 122.807 4.00012 121.929 4 121.03V16.8C4 13.4052 5.34857 10.1495 7.74903 7.74903C10.1495 5.34857 13.4052 4 16.8 4H119.2C122.595 4 125.851 5.34857 128.251 7.74903C130.651 10.1495 132 13.4052 132 16.8V93.6Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndlessCallsEmails);
export default __webpack_public_path__ + "static/media/endless-calls-emails.debaf87eb152d70265ff3b1621958c50.svg";
export { ForwardRef as ReactComponent };